export default __webpack_public_path__ + "static/media/AndreDavid.9344057b.JPG";